export default __webpack_public_path__ + "static/media/GravitricityLogo.41f20235.png";